/*
 * Copyright (C) 2018 - 2023 Entgra (Pvt) Ltd, Inc - All Rights Reserved.
 *
 * Unauthorised copying/redistribution of this file, via any medium is strictly prohibited.
 *
 * Licensed under the Entgra Commercial License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       https://entgra.io/licenses/entgra-commercial/1.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import React from 'react';
import axios from 'axios';
import { handleApiError } from '../../../../../../../../../../services/utils/errorHandler';
import { withTranslation } from 'react-i18next';
import { withConfigContext } from '../../../../../../../../../../components/ConfigContext';
import {
  Button,
  Checkbox,
  Divider,
  Form,
  notification,
  PageHeader,
  Result,
} from 'antd';
import { isAuthorized } from '../../../../../../../../../../services/utils/authorizationHandler';
import HtmlComments from '../../../../../../../../../../components/ReactHtmlComments/HtmlComments';
import Authorized from '../../../../../../../../../../components/Authorized';

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 24 },
    md: { span: 16 },
    lg: { span: 10 },
    xl: { span: 10 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 24 },
    md: { span: 12 },
    lg: { span: 8 },
    xl: { span: 8 },
  },
};

const buttonFormItem = {
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 24 },
    md: { span: 16 },
    lg: { span: 20 },
    xl: { span: 18 },
  },
};

class ViewRoles extends React.Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);
    this.config = this.props.context;
    this.state = {
      viewRolesConfigData: [],
    };
  }

  componentDidMount() {
    if (isAuthorized(this.config.scopes, ['perm:admin:metadata:view'])) {
      this.getRolesConfigs();
    }
  }

  getRolesConfigs = () => {
    const { t } = this.props;
    let metaKey = 'SHOW_ALL_ROLES';
    axios
      .get(
        window.location.origin +
          this.config.serverConfig.invoker.uri +
          '/device-mgt/v1.0/metadata/' +
          metaKey,
      )
      .then(res => {
        if (res.data.data && res.data.data.metaValue) {
          this.setState({
            viewRolesConfigData: JSON.parse(res.data.data.metaValue),
          });
          this.formRef.current.setFieldsValue(this.state.viewRolesConfigData);
        }
      })
      .catch(error => {
        handleApiError(
          error,
          t('api_loadError', { label: t('label_View_Roles') }),
        );
      });
  };

  updateRolesConfig = values => {
    const { t } = this.props;

    const requestPayload = {
      dataType: 'STRING',
      metaKey: 'SHOW_ALL_ROLES',
      metaValue: values.metaValue,
    };

    let apiUrl =
      window.location.origin +
      this.config.serverConfig.invoker.uri +
      '/device-mgt/v1.0/metadata/';

    axios
      .put(apiUrl, requestPayload, {
        headers: { 'Content-Type': 'application/json' },
      })
      .then(res => {
        notification.success({
          message: t('api_successMsg'),
          description: t('api_updateConfigMsg', {
            label: t('label_View_Roles'),
          }),
        });
      })
      .catch(error => {
        this.setState({ loading: false });
        handleApiError(
          error,
          t('api_updateConfigError', { label: t('label_View_Roles') }),
          t,
        );
      });
  };

  onFinish = values => {
    const configPayload = {};
    configPayload.metaValue = JSON.stringify(values);
    this.updateRolesConfig(configPayload);
  };

  render() {
    const { t } = this.props;
    return (
      <div>
        <HtmlComments
          permission={'/permission/admin/device-mgt/metadata/view'}
        />
        <Authorized
          scope={[['perm:admin:metadata:view']]}
          yes={
            <div>
              <div>
                <Divider>
                  <PageHeader
                    className="site-page-header-responsive"
                    subTitle={t('label_roleConfigs')}
                  />
                </Divider>
              </div>
              <HtmlComments
                permission={'/permission/admin/device-mgt/metadata/create'}
              />
              <Form
                {...formItemLayout}
                name="addViewRoles"
                onFinish={this.onFinish}
                ref={this.formRef}
              >
                <Form.Item
                  label={t('label_viewAllRoles')}
                  name="isUserAbleToViewAllRoles"
                  valuePropName="checked"
                >
                  <Checkbox />
                </Form.Item>
                <Form.Item {...buttonFormItem}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{ float: 'right' }}
                  >
                    {t('label_save')}
                  </Button>
                </Form.Item>
              </Form>
            </div>
          }
          no={
            <Result
              status="403"
              title={t('noPerm_accessPageTitle')}
              subTitle={t('noPerm_contactSysAdmin')}
            />
          }
        />
      </div>
    );
  }
}

export default withConfigContext(withTranslation()(ViewRoles));
